package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class PrescriptionCategory(private val literal: String) : IEnumType {
	解表方("解表方"),
	泻下剂("泻下剂"),
	和解剂("和解剂"),
	清热剂("清热剂"),
	祛暑剂("祛暑剂"),
	温里剂("温里剂"),
	补益剂("补益剂"),
	固涩剂("固涩剂"),
	安神剂("安神剂"),
	开窍剂("开窍剂"),
	理气剂("理气剂"),
	理血剂("理血剂"),
	治风剂("治风剂"),
	治燥剂("治燥剂"),
	祛湿剂("祛湿剂"),
	祛痰剂("祛痰剂"),
	消食剂("消食剂"),
	驱虫剂("驱虫剂"),
	涌吐剂("涌吐剂"),
	治疡方("治疡方");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "prescription_category"}
	override fun getLiteral(): String {return literal}
}
